import { render, staticRenderFns } from "./DashboardCalculationGeniusItem.vue?vue&type=template&id=830425b0&scoped=true&"
import script from "./DashboardCalculationGeniusItem.vue?vue&type=script&lang=js&"
export * from "./DashboardCalculationGeniusItem.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCalculationGeniusItem.vue?vue&type=style&index=0&id=830425b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830425b0",
  null
  
)

/* custom blocks */
import block0 from "./DashboardCalculationGeniusItem.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports